import { __decorate } from "tslib";
import Vue from "vue";
import Component from 'vue-class-component';
let NavCreateRoom = class NavCreateRoom extends Vue {
};
NavCreateRoom = __decorate([
    Component
], NavCreateRoom);
export default NavCreateRoom;
